import {
  CollectionDropdownComponent as BaseComponent
} from '../../../../../app/shared/collection-dropdown/collection-dropdown.component';
import { Component } from '@angular/core';

@Component({
  selector: 'ds-collection-dropdown',
  templateUrl: '../../../../../app/shared/collection-dropdown/collection-dropdown.component.html',
  // templateUrl: './collection-dropdown.component.html',
  styleUrls: ['../../../../../app/shared/collection-dropdown/collection-dropdown.component.scss']
  // styleUrls: ['./collection-dropdown.component.scss']
})
export class CollectionDropdownComponent extends BaseComponent {

}
